<template>
  <ul class="app-navigation">
    <li v-if="!isAuthenticated && isLoginPossible">
      <RouterLink class="inverted" :to="{ path: '/login' }">
        {{ $t('nav.login') }}
      </RouterLink>
    </li>

    <template v-if="isAuthenticated">
      <li>
        <RouterLink class="inverted" :to="{ path: '/' }">
          {{ $t('nav.dashboard') }}
        </RouterLink>
      </li>

      <li>
        <RouterLink class="inverted" :to="{ path: '/profile' }">
          {{ $t('nav.profile') }}
        </RouterLink>
      </li>

      <li>
        <RouterLink class="inverted" :to="{ path: '/results' }">
          {{ $t('nav.results') }}
        </RouterLink>
      </li>

      <li>
        <RouterLink class="inverted" :to="{ path: '/logout' }">
          {{ $t('nav.logout') }}
        </RouterLink>
      </li>
    </template>
  </ul>
</template>

<script lang="ts" setup>
defineProps({
  isAuthenticated: {
    type: Boolean,
    default: false,
  },

  isLoginPossible: {
    type: Boolean,
    default: false,
  },
})
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/globals';

.app-navigation {
  display: flex;
  flex-flow: column nowrap;
  margin: 0;
  padding: 0 0 0 2em;
  list-style: none;

  @media screen and (min-width: $break-point-laptop) {
    flex-flow: row nowrap;
    padding: 0;
    gap: 1.25em;
  }

  li > a {
    display: block;
    padding: 1em 0;

    @media screen and (min-width: $break-point-laptop) {
      padding: 0.5em 0;
    }
  }
}
</style>
